import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import i18n from "@dhis2/d2-i18n";
import Globalclasses from "../../App.module.css";
import { makeStyles } from "@material-ui/core/styles";
import { apiServices } from "../../services/apiServices";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import { InputLabel, Input } from "@material-ui/core";
import OfflineDb from "../../db";
import { useHistory } from "react-router";
import Grid from "@material-ui/core/Grid";
import {
  Button,
  ButtonStrip,
  Divider,
  InputFieldFF,
  SingleSelectFieldFF,
  ReactFinalForm,
  hasValue,
  InputField,
  CircularLoader,
  CenteredContent,
} from "@dhis2/ui";
import { withTranslation, Trans, useTranslation } from "react-i18next";
import swal from "sweetalert";
import { useGlobalSpinnerActionsContext } from "../../context/GlobalSpinnerContext";

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import ArrowBack from '@material-ui/icons/ArrowBack';

import { setLoginUser } from "../../redux/actions/action";

//import {Configuration} from '../../assets/data/config'
import "../../assets/css/customstyles.css";
import "../../assets/css/theme_grey.css";
import "../../assets/css/theme_blue.css";
import "../../assets/css/theme_green.css";
import "../../assets/css/theme_red.css";

const { Form, Field } = ReactFinalForm;

function EnterToken() {
  const [sessionUserBoValue, setSessionUserBoValue] = React.useState(null);
  const [input, setInput] = useState("");
  const [searchResult, setSearchResult] = useState([]);
  const [token, setToken] = useState("SAVECHILD");
  const { t } = useTranslation();
  const history = useHistory();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const [Configuration, setConfiguration] = useState(null);
  async function getMetaData() {
    let loginDetails = await OfflineDb.getDataFromPouchDB("loginDetails");
    if (loginDetails && loginDetails.data)
      setSessionUserBoValue(loginDetails.data);

    let configurations = await OfflineDb.getDataFromPouchDB("configurations");
    if (
      configurations &&
      configurations.data &&
      configurations.data.configuration
    )
      setConfiguration(configurations.data.configuration);
  }
  useEffect(() => {
    getMetaData();
    /*OfflineDb.removeDataFromPouchDB('activeCaseDetails')
        OfflineDb.removeDataFromPouchDB('activeCaseFormData')
        OfflineDb.removeDataFromPouchDB('linkContactFlag')
        OfflineDb.setDataIntoPouchDB('transferFlag', {type:null})
        if(localStorage.getItem('referral-type')){
            localStorage.removeItem('referral-type')
        }*/
  }, []);

  //once user bco is set call getContactList function
  useEffect(() => {
    if (sessionUserBoValue != null && Configuration != null) {
      //do something here
    }
  }, [sessionUserBoValue, Configuration]);

  function onSubmit() {
    let tokenValue = document.getElementById("enter-code").value;
    console.log("here", token, tokenValue);
    if (tokenValue) {
      setGlobalSpinner(true);
      apiServices
        .postAPI("save/mfa/user/check/validtoken", {
          username: sessionUserBoValue.userCredentials.username,
          token: tokenValue,
        })
        .then((res) => {
          setGlobalSpinner(false);
          if (
            res &&
            res.data &&
            res.data.status &&
            res.data.status == "success"
          ) {
            OfflineDb.setDataIntoPouchDB("token", tokenValue);
            history.push("/generatePin");
          } else {
            swal({
              title: t("Alert"),
              text: t("You have entered invalid code!"),
              icon: "error",
              button: t("Close"),
            });
          }
        })
        .catch((err) => {
          setGlobalSpinner(false);
          swal({
            title: t("Alert"),
            text: t("Sorry something went wrong, please try again later"),
            icon: "error",
            button: t("Close"),
          });
        });
    } else {
      swal({
        title: t("Alert"),
        text: t("Please enter the code"),
        icon: "error",
        button: t("Close"),
      });
    }
  }

  const goback = () => {
    OfflineDb.getAllEntities().then(res=>{
			if(res == undefined || res.total_rows == 0){
				localStorage.clear()
				OfflineDb.deleteDatabse().then(res=>{
					//(window.cordova) ? navigator.app.exitApp() : window.location.reload()
					setLoginUser(false)
          history.push("/login");
				}).catch(err=>{
					//(window.cordova) ? navigator.app.exitApp() : window.location.reload()
					setLoginUser(false)
          history.push("/login");
				}) 
			}else{
				swal({
					title: t("Offline data"),
					text: t("Offline records found, please sync data before logout"),
					icon: "warning",
					buttons: "Close",
				})
			}
			
		})
  }

  return (
    <div className={Globalclasses.container}>
      <main
        style={{
          display: "flex",
          height: "100%",
          width: "100%",
        }}
      >
        <section
          style={{
            backgroundColor: "#fff",
            flexGrow: 1,
            padding: 0,
            overflowY: "auto",
            overflowX: "hidden",
            height: "calc(100vh - 5px)"
          }}
        >
          <AppBar position="static" className="mfa-header">
            <Toolbar>
              <IconButton
                edge="start"
                // className={classes.menuButton}
                color="inherit"
                aria-label="go back"
                onClick={() => goback()}
              >
                <ArrowBack />
              </IconButton>
            </Toolbar>
          </AppBar>
          <Grid container spacing={3} className="margin-top-100px">
            <Grid item xs={12} sm={12} md={12} className="">
              <div className="innerdiv">
                <p className="zero text-center">
                  <div className="useravtarimg" />
                </p>
                <div className="center">
                  <h1>{t("2-Step Verification")}</h1>
                  <h3 class="center">
                    {t("Welcome")}{" "}
                    <span class="username">
                      {sessionUserBoValue ? sessionUserBoValue.displayName : ""}
                    </span>
                  </h3>
                  {/*<p >{t('To help keep your email, photos and other content safe complete the task below.')}</p>*/}
                </div>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={12} className="">
              <Form
                onSubmit={onSubmit}
                render={({
                  handleSubmit,
                  form,
                  submitting,
                  pristine,
                  values,
                }) => (
                  <form className="fullWidth noBG" onSubmit={handleSubmit}>
                    <div className="innertabdivreg">
                      <Grid container spacing={3} xs={12} lg={12}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                          <Field
                            name="enter-code"
                            id="enter-code"
                            label={t("Enter account activation code")}
                            formControlProps={{ className: "my-class" }}
                            component={InputFieldFF}
                            type="text"
                          ></Field>
                        </Grid>
                      </Grid>
                    </div>
                    <span style={{"fontSize": "12px"}}>Note : Default activation code for test users is 123456</span>
                    <div className="buttons">
                      <button
                        className="regformsubmitbtn"
                        type="submit"
                        disabled={submitting || pristine}
                      >
                        {t("Submit")}
                      </button>
                    </div>
                  </form>
                )}
              />
            </Grid>
          </Grid>
        </section>
      </main>
    </div>
  );
}

export default connect(null, { setLoginUser })(EnterToken);
